import { Vector2, Vector3 } from "three";
import { MeasurePoint, MonoplotMeasurePoint } from "./internal";
/**
 * Calculates approximative measurements based on a ray-groundplane-intersection...
 * @class MonoApproxMeasurePoint
 * @extends MeasurePoint
 * @constructor
 */
export class MonoApproxMeasurePoint extends MeasurePoint {
    constructor(geoframe, mouseX, mouseY, maxdist, disp) {
        super();
        this.offsetEasting = 0;
        this.offsetNorthing = 0;
        this.offsetHeight = 0;
        this.Northing = 0;
        this.Easting = 0;
        this.Height = 0;
        this.Omega = 0;
        this.Phi = 0;
        this.Kappa = 0;
        this.disparity = 0.0;
        this.quality = 0;
        /**
         * Bildkoordinate x'
         * @property {number} imageX
         */
        this.imageX = 0.0;
        /**
         * Bildkoordinate y
         * @property {number} imageY
         */
        this.imageY = 0.0; // Bildkoordinate y'.
        /**
         * is set to true if calculation could be inaccurate. see warntext for details
         * @type {boolean}
         */
        this.warning = false;
        /**
         * further information why calculation could be inacurrate
         * @type {string}
         */
        this.warntext = "";
        this.maxdist = 0;
        this.distance = 0;
        this.geoframecollection = null;
        this.geoframe = null;
        this.color = null;
        this.disparityInmm = -1;
        this.geoframe = geoframe;
        this.geoframecollection = geoframe.parentGeoFrameCollection;
        this.mouseX = mouseX;
        this.mouseY = mouseY;
        this.framenumber = geoframe.getFramenumber();
        this.offsetEasting = this.geoframe.easting;
        this.offsetNorthing = this.geoframe.northing;
        this.offsetHeight = this.geoframe.height;
        this.Omega = (this.geoframe.omega * Math.PI) / 180;
        this.Phi = (this.geoframe.phi * Math.PI) / 180;
        this.Kappa = (this.geoframe.kappa * Math.PI) / 180;
        this.disparity = disp;
        this.maxdist = maxdist;
        this.calcCoordinates(mouseX, mouseY);
        this.checkCoordinates();
    }
    isValid() {
        if (!isFinite(this.Easting) ||
            isNaN(this.Easting) ||
            !isFinite(this.Northing) ||
            isNaN(this.Northing) ||
            !isFinite(this.Height) ||
            isNaN(this.Height)) {
            return false;
        }
        return true;
    }
    /**
     * Calculates the coordinates out of the mouse position
     *
     * @param {number} mouseX - from canvas coordinates canvas left-top is origin !
     * @param {number} mouseY - from canvas coordinates canvas left-top is origin !
     */
    calcCoordinates(mouseX, mouseY) {
        const mh = this.geoframe.scene.getMeasureHandler();
        const measureinfo = this.geoframe.getMeasureInfo();
        const mapcoorobj = mh.mouseToMap(mouseX, mouseY, this.geoframe);
        const mc = new Vector2(mapcoorobj[0].coords.x, mapcoorobj[0].coords.y);
        const senscoor = mh.mapToSensor(mc, this.geoframe);
        const imgcoor = mh.sensorToImage(senscoor, this.geoframe);
        //Disparitaet schaetzen fuer Mono-Bilder
        const alpha = (-1 * measureinfo.tilt * Math.PI) / 180;
        const Y = -1 * measureinfo.height; //camera height
        this.quality = 0;
        this.color = this.geoframecollection.imagequadtree.readPixelValue(mouseX, mouseY, false);
        //calculate the depth in m
        const depth = measureinfo.imagemeta.focallength /
            ((Math.cos(alpha) * imgcoor.y - measureinfo.imagemeta.focallength * Math.sin(alpha)) / Y);
        const modelcoor = mh.imageToModel(imgcoor, depth, null, this.geoframe);
        const worldcoor = mh.modelToWorld(modelcoor, null, this.geoframe);
        this.Easting = worldcoor.x;
        this.Northing = worldcoor.y;
        this.Height = worldcoor.z;
    }
    /**
     * returns the point values as vec3 object.
     * @return {Vector3}
     */
    getVec3() {
        const vec = new Vector3(this["Easting"], this["Northing"], this["Height"]);
        return vec;
    }
    /**
     * returns the point values as vec3 object.
     * @return {MeasurePoint}
     */
    copy() {
        const pointcopy = new MonoplotMeasurePoint(this.geoframe, this.mouseX, this.mouseY, this.maxdist);
        pointcopy.framenumber = this.framenumber;
        pointcopy["Height"] = this["Height"];
        pointcopy["Easting"] = this["Easting"];
        pointcopy["Northing"] = this["Northing"];
        return pointcopy;
    }
    /**
     * checks if the measurement is in Range
     */
    checkCoordinates() {
        this.warntext = "";
        this.warning = false;
        if (this.maxdist == null) {
            this.warning = true;
            this.warntext = "No maximal range value set !";
            return;
        }
        const d = Math.sqrt(Math.pow(this["Easting"] - this.offsetEasting, 2) +
            Math.pow(this["Northing"] - this.offsetNorthing, 2) +
            Math.pow(this["Height"] - this.offsetHeight, 2));
        this.distance = d;
        if (d > this.maxdist) {
            this.warning = true;
            this.warntext = "Position too far from projection center";
            return;
        }
        if (!this.isValid()) {
            this.warning = true;
            this.warntext = "Inavlid Values in Northing/Easting/Height";
            return;
        }
    }
}
//# sourceMappingURL=monoapproxmeasurepoint.js.map